import { Gradebook, Item, Result, Score, Tunnel } from './index';
import { CreateItemRequest } from './msg-create-line-item-req';
import { CreateItemResponse, isCreateItemResponse } from './msg-create-line-item-res';
import { GetItemsRequest } from './msg-get-line-items-req';
import { GetItemsResponse, isGetItemsResponse } from './msg-get-line-items-res';
import { GetResultsRequest } from './msg-get-results-req';
import { GetResultsResponse, isGetResultsResponse } from './msg-get-results-res';
import { SubmitScoreRequest } from './msg-submit-score-req';
import { isSubmitScoreResponse, SubmitScoreResponse } from './msg-submit-score-res';
import { generateCorrelationId, isCorrelated } from './tunnel-message-data';

/**
 * @hidden
 */
export class TunnelGradebook implements Gradebook {
    constructor(private readonly tunnel: Tunnel) {
    }
    createItem(item: Omit<Item, "id" | "ltiLinkId" | "resourceLinkId">): Promise<Item> {
        return new Promise<Item>((resolve, reject) => {
            const id = generateCorrelationId();
            const subscription = this.tunnel.subscribe(function (message: MessageEvent<CreateItemResponse>) {
                if (isCreateItemResponse(message)) {
                    const response = message.data;
                    if (isCorrelated(response, id)) {
                        if (!response.err) {
                            resolve(response.value);
                        } else {
                            reject(response.err);
                        }
                        subscription.dispose();
                    }
                }
            });
            this.tunnel.postMessage<CreateItemRequest>({ type: '@stemcstudio/gradebook:create-item', id, item });
        });
    }
    getItems(): Promise<Item[]> {
        return new Promise<Item[]>((resolve, reject) => {
            const id = generateCorrelationId();
            const subscription = this.tunnel.subscribe(function (message: MessageEvent<GetItemsResponse>) {
                if (isGetItemsResponse(message)) {
                    const response = message.data;
                    if (isCorrelated(response, id)) {
                        if (!response.err) {
                            resolve(response.value);
                        } else {
                            reject(response.err);
                        }
                        subscription.dispose();
                    }
                }
            });
            this.tunnel.postMessage<GetItemsRequest>({ type: '@stemcstudio/gradebook:get-items', id });
        });
    }
    getResults(itemId: string): Promise<Result[]> {
        return new Promise<Result[]>((resolve, reject) => {
            const id = generateCorrelationId();
            const subscription = this.tunnel.subscribe(function (message: MessageEvent<GetResultsResponse>) {
                if (isGetResultsResponse(message)) {
                    const response = message.data;
                    if (isCorrelated(response, id)) {
                        if (!response.err) {
                            resolve(response.value);

                        } else {
                            reject(response.err);
                        }
                        subscription.dispose();
                    }
                }
            });
            this.tunnel.postMessage<GetResultsRequest>({ type: '@stemcstudio/gradebook:get-results', id, itemId });
        });
    }
    submitScore(itemId: string, score: Score): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            const id = generateCorrelationId();
            const subscription = this.tunnel.subscribe(function (message: MessageEvent<SubmitScoreResponse>) {
                if (isSubmitScoreResponse(message)) {
                    const response = message.data;
                    if (isCorrelated(response, id)) {
                        if (!response.err) {
                            resolve();
                        } else {
                            reject(response.err);
                        }
                        subscription.dispose();
                    }
                }
            });
            this.tunnel.postMessage<SubmitScoreRequest>({ type: '@stemcstudio/gradebook:submit-score', id, itemId, score });
        });
    }
}
